import { Route } from 'react-router-dom';

const AuthRoute = ({ component: Component, auths, path, checkAuth, ...rest }) => <Route
    render={props => (<Component {...props} />)}
    {...rest}
  />;

export default AuthRoute;
